import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ReportDishFilter from './components/ReportDishFilter';
import ReportDishTable from './components/ReportDishTable';
import ReportDishChart from './components/ReportDishChart';
import { getDate, getPermissionRestaurant, isEmptyObject } from '../../../utils/utils';
import { getListReportDish, handleChangeFilters } from './actions';
import { trans } from '../../../localization/index';
import {
  changeTableActivePage,
  changeTablePageSize,
} from '../../../redux/genericAction';
import { EnumMerchantPermission, EnumPage } from '../../../constants/enum';

class ReportDish extends Component {
  componentDidMount() {
    const {
      currentRestaurant,
      handleChangeFiltersConnect,
      getListReportDishConnect,
      restaurants,
    } = this.props;
    const allowedRestaurants = getPermissionRestaurant(
      restaurants,
      EnumMerchantPermission.REPORT_ALL.id,
    );

    if (!isEmptyObject(allowedRestaurants)) {
      if (!isEmptyObject(currentRestaurant) && currentRestaurant.restaurant_id > 0) {
        const { name: label, restaurant_id: value } = currentRestaurant;
        handleChangeFiltersConnect('restaurant', {
          label,
          value,
        });
      } else {
        const { name: label, restaurant_id: value } = restaurants[0];
        handleChangeFiltersConnect('restaurant', {
          label,
          value,
        });
      }
      getListReportDishConnect();
    }
  }

  handleSearchToday = () => {
    const { handleChangeFiltersConnect, getListReportDishConnect } = this.props;
    handleChangeFiltersConnect('fromDate', getDate());
    handleChangeFiltersConnect('toDate', getDate());
    getListReportDishConnect();
  };

  render() {
    const {
      restaurants,
      reportDish,
      handleChangeFiltersConnect,
      getListReportDishConnect,
      changeTablePageSizeConnect,
      changeTableActivePageConnect,
    } = this.props;
    const { filters, table } = reportDish;
    const { itemList } = table;
    const { isShowChart } = filters;
    return (
      <React.Fragment>
        <h2 className="title-page">{trans('mod_report_dish')}</h2>
        <ReportDishFilter
          filters={filters}
          restaurants={restaurants}
          handleSearch={getListReportDishConnect}
          handleSearchToday={this.handleSearchToday}
          handleChangeFilters={handleChangeFiltersConnect}
        />
        {!isShowChart ? (
          <ReportDishTable
            table={table}
            getList={getListReportDishConnect}
            changePageSize={changeTablePageSizeConnect}
            changeActivePage={changeTableActivePageConnect}
          />
        ) : <ReportDishChart data={itemList} />}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  restaurants: state.app.restaurants,
  currentRestaurant: state.setting.currentRestaurant,
  reportDish: state.report.dish,
});

const mapDispatchToProps = (dispatch) => {
  const PAGE = EnumPage.REPORT_DISH.id;
  return {
    changeTablePageSizeConnect: pageSize =>
      dispatch(changeTablePageSize(PAGE, pageSize)),
    changeTableActivePageConnect: activePage =>
      dispatch(changeTableActivePage(PAGE, activePage)),
    handleChangeFiltersConnect: (name, value) => {
      dispatch(changeTableActivePage(PAGE, 1));
      return dispatch(handleChangeFilters(name, value));
    },
    getListReportDishConnect: () => dispatch(getListReportDish()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ReportDish),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportDish/ReportDish.jsx